/**
 * Регистрация service worker'а — только для сайта и установленного приложения.
 *
 * Внутри Telegram он не нужен: мини-апп всегда открывается онлайн и живёт
 * ровно один сеанс. Лишний слой между ним и сетью — лишний способ что-нибудь
 * сломать, поэтому там мы его не ставим и, если он остался с прошлых версий,
 * снимаем.
 */

import { isTelegramMiniApp } from "./platform";

export function registerServiceWorker(): void {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  if (isTelegramMiniApp) {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) =>
        registrations.forEach((registration) => registration.unregister())
      )
      .catch(() => undefined);
    return;
  }

  // Регистрируем сразу: Chrome отдаёт beforeinstallprompt только после активного SW.
  navigator.serviceWorker.register("/sw.js").catch((error) => {
    // Неудача регистрации не должна ничего ломать: приложение обязано
    // работать и без офлайн-слоя.
    console.warn("Service worker registration failed:", error);
  });
}
